import { Link } from "react-router";
import { Home, ArrowLeft } from "lucide-react";

export function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6">
      <div className="text-center">
        <h1 className="text-8xl text-[#1a2d50] mb-4" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 900 }}>
          404
        </h1>
        <h2 className="text-2xl text-foreground mb-4" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 700 }}>
          Page Not Found
        </h2>
        <p className="text-muted-foreground mb-8 max-w-md mx-auto" style={{ lineHeight: 1.8 }}>
          The page you're looking for doesn't exist or has been moved. Let's get you back on track to building your smart home.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-accent text-white px-8 py-3.5 rounded-full hover:bg-accent/90 transition-all"
            style={{ fontWeight: 600 }}
          >
            <Home className="w-4 h-4" /> Go Home
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 bg-[#E9A319] text-white px-8 py-3.5 rounded-full hover:bg-[#d4920f] transition-all"
            style={{ fontWeight: 600 }}
          >
            <ArrowLeft className="w-4 h-4" /> Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}